import React from "react";
import CustomModal from "../common/CustomModel";
import Thankyou from "../assets/images/logo.webp";
const Success = ({ open, setOpen }) => {
  return (
    <div>
      <CustomModal
        open={open}
        onClickOutside={() => {
          setOpen(false);
        }}
      >
        <div className="modal-content thankyou-modal-content">
          <div className="th-cnt">
            <img className="thankyou-logo" src={Thankyou} alt="Thanks" />
            <h1 className="font-bold">Thank You</h1>
            <p>Your details has been successfully submitted</p>

            <div className="text-center">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setOpen(false);
                }}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </CustomModal>
    </div>
  );
};

export default Success;
